import { render, staticRenderFns } from "./ApprovedDispatchedInvoicesTable.vue?vue&type=template&id=af61ee76&scoped=true"
import script from "./ApprovedDispatchedInvoicesTable.vue?vue&type=script&lang=js"
export * from "./ApprovedDispatchedInvoicesTable.vue?vue&type=script&lang=js"
import style0 from "./ApprovedDispatchedInvoicesTable.vue?vue&type=style&index=0&id=af61ee76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af61ee76",
  null
  
)

export default component.exports